import { useMemo } from 'react';
import { useAppSelector } from './store/hooks';
import { UserAuthData } from './store/slices/authSlice';

export enum Permission {
  Viewer = 'dm_casops_viewer',
  AssetManagement = 'dm_casops_asset_management',
  GeofenceManagement = 'dm_casops_geofence_management',
  UserManagement = 'dm_casops_user_management',
  SafetyViewer = 'dm_casops_safety_viewer',
  SafetyManagement = 'dm_casops_safety_management',
  Admin = 'dm_casops_admin',
}

export const userIsLoggedIn = (user: UserAuthData): boolean => user.isLoggedIn;

export const userHasPermission = (user: UserAuthData, permission: Permission): boolean => {
  return user.isLoggedIn && user.permissions.includes(permission);
};

export const useIsUserWithPermission = (permission: Permission): boolean => {
  const user = useAppSelector(state => state.auth);

  const hasPermission = useMemo(() => userHasPermission(user, permission), [user, permission]);

  return hasPermission;
};

export const useIsViewer = (): boolean => useIsUserWithPermission(Permission.Viewer);

export const useIsAssetManagement = (): boolean =>
  useIsUserWithPermission(Permission.AssetManagement);

export const useIsGeofenceManagement = (): boolean =>
  useIsUserWithPermission(Permission.GeofenceManagement);

export const useIsUserManagement = (): boolean =>
  useIsUserWithPermission(Permission.UserManagement);

export const useIsAdmin = (): boolean => useIsUserWithPermission(Permission.Admin);
